import { NotFoundPageContents } from '../_components/pages/NotFound.client'

export default function NotFoundShop() {
  return <NotFoundPageContents />
}
